import { connectivityEstablished, connectivityLost } from './redux/actions';

export default function registerOnlineOfflineListener(store){
    window.addEventListener("online", () => store.dispatch(connectivityEstablished.call()));
    window.addEventListener("offline", () => store.dispatch(connectivityLost.call()));
}